<app-dt-card
  class="jerarquia-lum"
  titulo="Jerarquía de perfiles"
  icono="account_tree"
>
  @if (cargando()) {
    <div class="jl-cargando">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!cargando() && jerarquia(); as j) {
    <div class="jl-efectivo" [class.vacio]="!j.efectivo">
      @if (j.efectivo; as ef) {
        <mat-icon class="jl-efectivo-ico">check_circle</mat-icon>
        <span class="jl-efectivo-txt">
          <span class="jl-label">Perfil efectivo</span>
          <span class="perfil-chip" [class]="'n-' + ef.nivel">
            {{ nivelLabel(ef.nivel)
            }}{{ ef.perfilNombre ? ' · ' + ef.perfilNombre : '' }}
          </span>
        </span>
      }
      @if (!j.efectivo) {
        <mat-icon class="jl-efectivo-ico">info</mat-icon>
        <span class="jl-efectivo-txt sin">
          Esta luminaria no tiene ningún perfil (propio ni heredado).
        </span>
      }
    </div>

    <div class="jl-cadena">
      @for (n of j.niveles; track n.id; let last = $last) {
        <div
          class="jl-nivel"
          [class]="'n-' + n.nivel"
          [class.efectivo]="n.esEfectivo"
        >
          <div class="jl-rail">
            <div class="jl-badge">
              <mat-icon>{{ icono(n.nivel) }}</mat-icon>
            </div>
            @if (!last) {
              <span class="jl-line"></span>
            }
          </div>

          <div class="jl-card">
            <div class="jl-nivel-top">
              <span class="jl-label">{{ nivelLabel(n.nivel) }}</span>
              @if (n.prioridad !== null) {
                <span
                  class="jl-prioridad"
                  matTooltip="Prioridad del grupo (mayor gana)"
                >
                  <mat-icon>low_priority</mat-icon>
                  {{ n.prioridad }}
                </span>
              }
              @if (n.esEfectivo) {
                <span class="jl-efectivo-badge">
                  <mat-icon>check_circle</mat-icon>
                  Efectivo
                </span>
              }
            </div>
            <div class="jl-nivel-nombre">{{ n.nombre || 'Sin nombre' }}</div>
            @if (n.perfilNombre) {
              <span class="perfil-chip mini" [class]="'n-' + n.nivel">
                {{ n.perfilNombre }}
              </span>
            } @else {
              <span class="perfil-chip mini sin-perfil">Sin perfil</span>
            }
          </div>
        </div>
      }
    </div>
  }
</app-dt-card>
